var map = {
	"./BaseDescription": 78069,
	"./BaseDescription.vue": 78069,
	"./BaseHeaderComponent": 51708,
	"./BaseHeaderComponent.vue": 51708,
	"./BaseHowItWorks": 38142,
	"./BaseHowItWorks.vue": 38142,
	"./BaseMenu": 3796,
	"./BaseMenu.vue": 3796,
	"./BaseTopBanner": 82328,
	"./BaseTopBanner.vue": 82328,
	"./HowItWorksItem": 82602,
	"./HowItWorksItem.vue": 82602,
	"./MenuItem": 85809,
	"./MenuItem.vue": 85809
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 21525;
module.exports = webpackAsyncContext;